export default {
  Staking: {
    1: "0x73ec97f9b3694e230fee46c8309fef2d753ce1b1",
  },
  Rewards: {
    1: "0x099c0eba98713231f2585f1dd7dcb01e6a1e0dd1",
  },
};
